ready(function(){
  const openFroNo = document.getElementById('openFroNo');
  const closeFroNo = document.getElementById('closeFroNo');
  const froNo__modal = document.getElementById('froNo__modal');
  openFroNo.addEventListener('click', function (e) {
    froNo__modal.classList.add('animate-froNoOpen');
    froNo__modal.classList.remove('animate-froNoClose');
  });
  closeFroNo.addEventListener('click', function (e) {
    froNo__modal.classList.add('animate-froNoClose');
    froNo__modal.classList.remove('animate-froNoOpen');
  });
});